<template>
  <div class="my_bio">
    <transition appear @before-enter="beforeEnterBox" @enter="enterBox">
      <h2 data-index="0">Let me introduce myself:</h2></transition
    >
    <transition appear @before-enter="beforeEnter" @enter="enter">
      <p>
        {{ about_me }}
      </p>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    about_me: String,
    beforeEnter: Function,
    enter: Function,
    beforeEnterBox: Function,
    enterBox: Function,
  },
};
</script>
<style scoped>
.my_bio p {
  text-align: justify;
  white-space: pre-line;
}
</style>
